import axios from 'axios'
import storage from "./storage";
import store from "../redux/Store";
import '../config/config'


const api = global.constants.baseApi

export const test = () =>{
    return fetchGet(api + 'test/test')
}

// export const createALiPayLink = (orderId) =>{
// 	return fetchPost(api + 'plan/create_ali_pay_link/'+ orderId)
// }

export const utm = (utm) => {
	let data = new FormData();
	data.append('utm', utm)
	return fetchPost(api + 'analysis/init', data)
}

export const queryPayInfo = (orderId) => {
	let data = new FormData();
	data.append('orderId', orderId)
	return fetchPost(api + 'plan/query_pay_info', data)
}

export const createPayMethodPrice = (orderId, promeCode, payMethod) => {
	let data = new FormData();
	data.append('orderId', orderId)
	data.append('promeCode', promeCode)
	data.append('payMethod', payMethod)
	return fetchPost(api + 'plan/create_pay_method_price', data)
}

export const bingImage = () =>{
    return fetchGet(api + 'other/bing')
}

export const checkRegisteredCheck = (key) =>{
  return fetchGet(api + 'signUp/attest/' + key)
}

export const subVideo = (title, series, vid, aaliid, subTags, isFree, desc, code, introduction) => {
    let data = new FormData();
    data.append('title', title)
    data.append('series', series)
    data.append('vid', vid)
    data.append('aaliid', aaliid)
    data.append('subTags', subTags)
    data.append('isFree', isFree)
    data.append('desc', desc)
    data.append('code', code)
    data.append('introduction', introduction)
    return fetchPost(api + 'admin/subVideo', data)
}

export const analysisTiming = () => {
	return fetchPost(api + 'analysis/autoTiming')
}

export const analysisMoving = () => {
	return fetchPost(api + 'analysis/autoMoving')
}

export const seriesInfos = () => {
    return fetchPost(api + 'admin/seriesInfos')
}

export const tagsInfo = () => {
    return fetchPost(api + 'admin/tagsInfo')
}

export const allTagInVideo = (tag) => {
    let data = new FormData();
    data.append('tag_text', tag)
    return fetchPost(api + 'video/allTagInVideo', data)
}

export const getUserOrderInfo = () =>{
    return fetchPost(api + 'order/info')
}

export const chekcOrder = (planId) => {
	let data = new FormData();
	data.append('planId', planId)
	return fetchPost(api + 'plan/chekcOrder', data)
}

export const getUserName = () => {
	let data = new FormData();
	return fetchPost(api + 'account/userName', data)
}

export const subscribe = (subscribeType, payMethod, utc) => {
	let data = new FormData();
	data.append('subscribeType', subscribeType)
	data.append('payMethod', payMethod)
	data.append('utc', utc)
	return fetchPost(api + 'plan/subscribe', data)
}

export const getUserPlans = (checkToken) =>{
	return fetchPost(api + 'plan/planList', null, checkToken)
}

export const getVideoAllTags = () =>{
    return fetchPost(api + 'video/allTags', null, false)
}
export const allVideos = () =>{
    return fetchPost(api + 'video/allVideos',null, false)
}

export const getVideoInfo = (id) => {
    let data = new FormData();
    data.append('id', id)
    return fetchPost(api + 'video/info', data)
}

export const getSeriesLCStatus = (seriesId) => {
    let data = new FormData();
    data.append('seriesId', seriesId)
    return fetchPost(api + 'series/LCStatus', data)
}

export const getLCStatus = (id, seriesId) => {
    let data = new FormData();
    data.append('videoId', id)
    data.append('seriesId', seriesId)
    return fetchPost(api + 'video/getLCStatus', data)
}

export const videoAddLean = (id, seriesId) => {
    let data = new FormData();
    data.append('videoId', id)
    data.append('seriesId', seriesId)
    return fetchPost(api + 'video/addLean', data)
}

export const videoAddCollect = (id, seriesId) => {
    let data = new FormData();
    data.append('videoId', id)
    data.append('seriesId', seriesId)
    return fetchPost(api + 'video/addCollect', data)
}

export const videoRemoveLean = (id, seriesId) => {
    let data = new FormData();
    data.append('videoId', id)
    data.append('seriesId', seriesId)
    return fetchPost(api + 'video/removeLean', data)
}

export const videoRemoveCollect = (id, seriesId) => {
    let data = new FormData();
    data.append('videoId', id)
    data.append('seriesId', seriesId)
    return fetchPost(api + 'video/removeCollect', data)
}

export const getAccountSeries = () =>{
    return fetchPost(api + 'account/userInfoAndSeries')
}

export const getUserInvitation = () =>{
    return fetchPost(api + 'account/userHaveInvitation')
}

export const exchangeUserInvitation = (type) =>{
	let data = new FormData();
	data.append('type', type)
    return fetchPost(api + 'account/exchange', data)
}


export const getSeriesInfoList = (id) =>{
    let data = new FormData();
    data.append('id', id)
    return fetchPost(api + 'series/list', data)
}

export const getSeriesInfo = (id) =>{
    let data = new FormData();
    data.append('id', id)
    return fetchPost(api + 'series/info', data)
}

export const getAllSeries = () =>{
    return fetchPost(api + 'series/main')
}

export const passwordForgetCheck = (key) => {
    return fetchGet(api + 'signUp/password_forget_check/' +  key)
}

export const password_forget_reset = (password, key) => {
    let data = new FormData();
    data.append('password', password)
    data.append('key', key)
    return fetchPost(api + 'signUp/password_forget_reset', data)
}

export const passwordForget = (email, vertify, flag) => {
    let data = new FormData();
    data.append('email', email)
    data.append('vertify', vertify)
    data.append('flag', flag)
    return fetchPost(api + 'signUp/password_forget', data)
}

export const emailReAttest = (email, vertify, flag) => {
    let data = new FormData();
    data.append('email', email)
    data.append('vertify', vertify)
    data.append('flag', flag)
    return fetchPost(api + 'signUp/email_re_attest', data)
}

export const login = (email, password, vertify, flag) => {
    let data = new FormData();
    data.append('email', email)
    data.append('password', password)
    data.append('vertify', vertify)
    data.append('flag', flag)
    return fetchPost(api + 'signUp/login', data)
}


export const signUp = (name, email, password, vertify, flag, invitation) => {
    let data = new FormData();
    data.append('name', name)
    data.append('email', email)
    data.append('password', password)
    data.append('vertify', vertify)
    data.append('flag', flag)
    data.append('invitation', invitation)
    return fetchPost(api + 'signUp/registered', data)
    // return fetchPost(api + 'signUp/registered', data)
}

export const templateListCount = (type) =>{
    let data = new FormData();
    data.append('type', type);
    return fetchPost(api + 'signUp/listCount', data)
}


export const templateList = (type, start, scope) =>{
    let data = new FormData();
    data.append('type', type);
    data.append('start', start);
    data.append('scope', scope);
    return fetchPost(api + 'webTemplate/list', data)
}



axios.interceptors.response.use(response => {
    //对响应数据做操作
    // console.log(response.data.code);
    if (response.data.code === 200){
        // console.log('请求成功');
        return response
    }

    if(response.data.code === '910' || response.data.code === 910) {
        // console.log('已过期重新登陆', response.data.code);
        window.location.href = '/login';
        alert('用户登录信息已过期, 请重新登录');
        storage.remove("token");
        store.dispatch({
            type: "logout"
        });
		store.dispatch({
			type: "display"
		});
		store.dispatch({
			type: "mine_display"
		});
        return Promise.reject(response);
    }
	if(response.data.code === '404' || response.data.code === 404) {
		// console.log('已过期重新登陆', response.data.code);
		window.location.href = '/404';
		return Promise.reject(response);
	}
    else {
        // console.log('请求异常', response.data.code);
        return Promise.reject(response);
    }

}, error => {
    //对响应数据错误做操作
    // console.log('请求error', error.message);
    return Promise.reject(error);
})


export function fetchPost(url, param, checkToken = true) {
    axios.defaults.headers['robin_token'] =  storage.get('token');
    axios.defaults.headers['checkToken'] =  checkToken;
    axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
    axios.defaults.headers['Access-Control-Allow-Origin'] = '*';

    axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
    axios.defaults.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS';
    return new Promise((resolve, reject) => {
        axios.post(url, param)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function fetchGet(url, param) {
    axios.defaults.headers['robin_token'] =  storage.get('token');
    axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
    axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
    axios.defaults.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS';


    return new Promise((resolve, reject) => {
        axios.get(url, param)
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
